import React from "react"
import styled from "styled-components"
import ModalBase from "@irati/ui/src/Modal"
import {H2} from "@irati/ui/src//Typography/Heading"
import {Card} from "@irati/ui/src/Layout"
import FormattedMessage from "@irati/utils/lang"
import Header from "./Header"

const IMAGE_SIZE = 140

const Modal = styled(ModalBase)`
  padding-top: ${IMAGE_SIZE / 2}px;
  .modal-content {
    max-width: 450px;
    margin: auto;
  }
  ${ModalBase.Inner} {
    padding: 0;
  }
`

interface MFAModalProps {
  header: string,
  show?: boolean
}

const MFAModal: React.FC<MFAModalProps> = ({children, header, ...props}) => {
  return (
    <Modal {...props}>
      <Header size={IMAGE_SIZE} />
      <H2 className="center">
        <FormattedMessage id={header} />
      </H2>
      <Card noBorder>{children}</Card>
    </Modal>
  )
}

export default MFAModal
